"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var YandexMapLoader = /** @class */ (function (_super) {
    tslib_1.__extends(YandexMapLoader, _super);
    function YandexMapLoader(props) {
        var _this = _super.call(this, props) || this;
        _this.setMapIsLoaded = function () {
            _this.setState({ isMapLoaded: true });
        };
        _this.state = {
            isMapLoaded: false,
        };
        return _this;
    }
    YandexMapLoader.prototype.componentDidMount = function () {
        var _this = this;
        if (window.ymaps === undefined) {
            var url = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU';
            var scriptNodeWithUrl = getScriptNode(url);
            if (!scriptNodeWithUrl) {
                var scriptNode = document.createElement('script');
                scriptNode.type = 'text/javascript';
                scriptNode.async = true;
                scriptNode.addEventListener('load', function () { return window.ymaps.ready(_this.setMapIsLoaded); }, false);
                scriptNode.src = url;
                document.head.appendChild(scriptNode);
            }
            else {
                scriptNodeWithUrl.addEventListener('load', function () { return window.ymaps.ready(_this.setMapIsLoaded); }, false);
            }
        }
        else {
            if (window.ymaps.Map !== undefined) {
                this.setMapIsLoaded();
            }
            else {
                window.ymaps.ready(this.setMapIsLoaded);
            }
        }
    };
    YandexMapLoader.prototype.render = function () {
        return this.state.isMapLoaded ? this.props.children : null;
    };
    return YandexMapLoader;
}(react_1.default.Component));
exports.YandexMapLoader = YandexMapLoader;
function getScriptNode(url) {
    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i += 1) {
        if (scripts[i].src === url) {
            return scripts[i];
        }
    }
    return null;
}
